import {
    Dialog,
    DialogBody,
    DialogHeader
} from "@material-tailwind/react";
  
  interface Props {
    open: boolean;
    toggleOpen: () => void;
    title: string;
    imageLinks?: string[];
  }
  
  const ImageModal = ({ open, toggleOpen, title, imageLinks }: Props) => {
  
    return (
      <>
        <Dialog open={open} handler={toggleOpen}>
          <DialogHeader>{title}</DialogHeader>
          {imageLinks && <DialogBody className="overflow-y-scroll" divider>
            {imageLinks.map(link => {
                return (
                    <img src={link} alt="img1" />
                )
            })}
          </DialogBody>}
        </Dialog>
      </>
    );
  }
  
  export default ImageModal;